const STORAGE_KEY = 'nexus.mesPatrio';
const CEREMONY_SEEN_KEY = 'nexus.vivaMexico';
export const MES_PATRIO_EVENT = 'nexus-mes-patrio';

const MEXICO_TZ = 'America/Mexico_City';

export function getMexicoCalendar(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: MEXICO_TZ,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }).formatToParts(now);
  const pick = (type) => Number(parts.find((part) => part.type === type)?.value);
  return { year: pick('year'), month: pick('month'), day: pick('day') };
}

export function parsePatrioQuery(search = typeof window !== 'undefined' ? window.location.search : '') {
  const value = new URLSearchParams(search).get('patrio');
  if (value === '1' || value === 'on') return { dress: true, ceremony: false };
  if (value === '0' || value === 'off') return { dress: false, ceremony: false };
  if (value === '15' || value === '16' || value === 'viva') return { dress: true, ceremony: true };
  return null;
}

function queryOverride() {
  if (typeof window === 'undefined') return null;
  return parsePatrioQuery(window.location.search);
}

export function isMesPatrioSeason(now = new Date()) {
  const { month, day } = getMexicoCalendar(now);
  return month === 9 && day >= 1 && day <= 16;
}

export function isGritoWindow(now = new Date()) {
  if (!isMesPatrioSeason(now)) return false;
  const { day } = getMexicoCalendar(now);
  return day === 15 || day === 16;
}

export function isIndependenciaDay(now = new Date()) {
  const { month, day } = getMexicoCalendar(now);
  return month === 9 && day === 15;
}

export function isCeremonyPreview() {
  return queryOverride()?.ceremony === true;
}

export function getMesPatrioPreference() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'off') return false;
    if (value === 'on') return true;
  } catch {
    /* ignore quota / private mode */
  }
  return null;
}

export function isMesPatrioEnabled(now = new Date()) {
  const forced = queryOverride();
  if (forced !== null) return forced.dress;
  const preference = getMesPatrioPreference();
  if (preference === false) return false;
  if (preference === true) return true;
  return isMesPatrioSeason(now);
}

function ceremonySeenStamp(now = new Date()) {
  const { year } = getMexicoCalendar(now);
  return `${year}-09-15`;
}

export function hasSeenIndependenciaCeremony(now = new Date()) {
  try {
    return localStorage.getItem(CEREMONY_SEEN_KEY) === ceremonySeenStamp(now);
  } catch {
    return false;
  }
}

let playedThisRuntime = false;

export function markIndependenciaCeremonySeen(now = new Date()) {
  if (isCeremonyPreview()) return;
  playedThisRuntime = true;
  try {
    localStorage.setItem(CEREMONY_SEEN_KEY, ceremonySeenStamp(now));
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MES_PATRIO_EVENT, { detail: { ceremony: 'seen' } }));
  }
}

export function shouldPlayIndependenciaCeremony(now = new Date()) {
  const forced = queryOverride();
  if (forced) return forced.ceremony;
  if (playedThisRuntime) return false;
  if (getMesPatrioPreference() === false) return false;
  if (!isIndependenciaDay(now)) return false;
  return !hasSeenIndependenciaCeremony(now);
}

export function setMesPatrioEnabled(on) {
  try {
    localStorage.setItem(STORAGE_KEY, on ? 'on' : 'off');
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MES_PATRIO_EVENT, { detail: { on: Boolean(on) } }));
  }
}
